import React from 'react';
import Slider from 'react-slick';
import { shape, string, number, arrayOf } from 'prop-types';

export default function ImageCarousel({ docketAttachments, currentImage }) {
    const settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: currentImage,
        className: 'c-slider',
        arrows: false

    };
    setTimeout(() => {
        const sliderTrack = document.querySelector('.c-slider .slide-wrapper');
        if (sliderTrack) {
            sliderTrack.focus();
        }
    }, 100);
    return (
        /* eslint-disable react/no-array-index-key */
        // The resources group does not contain unique id value from the data
        <Slider {...settings}>
            {docketAttachments.map((attachment, key) => (
                <div
                    key={`docketImage${key}`}
                    className="slide-wrapper"
                >
                    <img src={attachment.FileLocation} alt={attachment.Filename} />
                    <h3>{attachment.Filename}</h3>
                </div>
            ))}
        </Slider>
        /* eslint-enable react/no-array-index-key */
    );
}

ImageCarousel.propTypes = {
    currentImage: number.isRequired,
    docketAttachments: arrayOf(shape({
        FileLocation: string.isRequired,
        Filename: string.isRequired
    })).isRequired

};
